// @ts-nocheck
import React, { useState } from "react";
import { getImageUrl } from "../../../commons/assets_path";
import style from "./ChangePlan.module.scss";
import PropTypes from "prop-types";
import { SecondaryBtn } from "../../common/Payment/SecondaryBtn";
import { InfoBtn } from "../../common/Payment/InfoBtn";
import { useTranslation, Trans } from "react-i18next";

export const ChangePaidPlanModalBodyForOverseas = ({
  currentPlan,
  currentPaymentPeriod,
  afterPlanName,
  afterPlanInfo,
  selectPaymentPeriod,
  downGradeFlag,
  isLoading,
  handleClose,
  updatePlan,
  setCurrentPageNumber,
  changeModalCss,
  currency = null,
}) => {
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(false);
  const currencySymbol = currency.symbol;

  return (
    <>
      <div className={style.changePlanModalWrap}>
        <div className={style.changePlanModalTitle}>
          {t("ChangePaidPlanModalBodyForOverseas.プラン変更申し込み (1/2)")}
        </div>
        {downGradeFlag ? (
          <>
            <div className={style.changePlanModalDescription}>
              {currentPlan.plan_name === afterPlanName ? (
                <div style={{ margin: "20px 0px" }}>
                  <Trans
                    i18nKey="ChangePaidPlanModalBodyForOverseas.{currentPaymentPeriod}から{selectPaymentPeriod}への変更は次回更新日より適用されます。"
                    values={{
                      currentPaymentPeriod:
                        currentPaymentPeriod === "year"
                          ? t("ChangePaidPlanModalBodyForOverseas.年間契約")
                          : currentPaymentPeriod === "month"
                          ? t("ChangePaidPlanModalBodyForOverseas.月間契約")
                          : "",
                      selectPaymentPeriod:
                        selectPaymentPeriod === "month"
                          ? t("ChangePaidPlanModalBodyForOverseas.月間契約")
                          : selectPaymentPeriod === "year"
                          ? t("ChangePaidPlanModalBodyForOverseas.年間契約")
                          : "",
                    }}
                    components={{
                      span: <span className={style.changePlanModalDescriptionBold} />,
                    }}
                  />
                </div>
              ) : (
                <>
                  {
                    <Trans
                      i18nKey="ChangePaidPlanModalBodyForOverseas.{currentPlanName}から{afterPlanName}({selectPaymentPeriod})への変更は次回更新日より適用されます。"
                      values={{
                        currentPlanName: `${currentPlan.plan_name} ${t("ChangePaidPlanModalBodyForOverseas.プラン")}`,
                        afterPlanName: `${afterPlanName} ${t("ChangePaidPlanModalBodyForOverseas.プラン")}`,
                        selectPaymentPeriod:
                          selectPaymentPeriod === "month"
                            ? t("ChangePaidPlanModalBodyForOverseas.月間契約")
                            : selectPaymentPeriod === "year"
                            ? t("ChangePaidPlanModalBodyForOverseas.年間契約")
                            : "",
                      }}
                      components={{
                        span: <span className={style.changePlanModalDescriptionBold} />,
                      }}
                    />
                  }
                  {!(
                    (currentPlan.plan_name === t("ChangePaidPlanModalBodyForOverseas.プラス") &&
                      afterPlanName === t("ChangePaidPlanModalBodyForOverseas.ビジネス")) ||
                    (currentPlan.plan_name === t("ChangePaidPlanModalBodyForOverseas.プラス") &&
                      afterPlanName === t("ChangePaidPlanModalBodyForOverseas.エンタープライズ")) ||
                    (currentPlan.plan_name === t("ChangePaidPlanModalBodyForOverseas.ビジネス") &&
                      afterPlanName === t("ChangePaidPlanModalBodyForOverseas.エンタープライズ"))
                  ) && (
                    <div>
                      <Trans
                        i18nKey="ChangePaidPlanModalBodyForOverseas.{currentPlan}から{afterPlan}へ変更が完了すると、{currentPlan}で提供している機能等は自動的にご利用できなくなります。"
                        values={{
                          currentPlan: currentPlan.plan_name,
                          afterPlan: afterPlanName,
                        }}
                        components={{
                          span: <span className={style.changePlanModalDescriptionBold} />,
                        }}
                      />
                    </div>
                  )}
                  <div>
                    {
                      <Trans
                        i18nKey="ChangePaidPlanModalBodyForOverseas.申し込み内容と利用規約をご確認の上、支払い方法の選択に進んでください。"
                        components={{
                          a: (
                            <a
                              href="https://lp.yoom.fun/en/terms"
                              target="_blank"
                              rel="noreferrer"
                              style={{ position: "relative", zIndex: 1 }}
                            />
                          ),
                        }}
                      />
                    }
                  </div>
                </>
              )}
            </div>
          </>
        ) : (
          <>
            {currentPlan.plan_name === afterPlanName ? (
              <div className={style.changePlanModalDescription}>
                <Trans
                  i18nKey="ChangePaidPlanModalBodyForOverseas.{currentPaymentPeriod}から{selectPaymentPeriod}への変更は即時行われます。取り消すことはできません。"
                  values={{
                    currentPaymentPeriod:
                      currentPaymentPeriod === "year"
                        ? t("ChangePaidPlanModalBodyForOverseas.年間契約")
                        : t("ChangePaidPlanModalBodyForOverseas.月間契約"),
                    selectPaymentPeriod:
                      selectPaymentPeriod === "year"
                        ? t("ChangePaidPlanModalBodyForOverseas.年間契約")
                        : t("ChangePaidPlanModalBodyForOverseas.月間契約"),
                  }}
                />
                <div>
                  {
                    <Trans
                      i18nKey="ChangePaidPlanModalBodyForOverseas.申し込み内容と利用規約をご確認の上、支払い方法の選択に進んでください。"
                      components={{
                        a: <a href="https://lp.yoom.fun/en/terms" target="_blank" rel="noreferrer" />,
                      }}
                    />
                  }
                </div>
              </div>
            ) : (
              <>
                <div className={style.changePlanModalDescription}>
                  {t(
                    "ChangePaidPlanModalBodyForOverseas.{currentPlanName}から{afterPlanName}({selectPaymentPeriod})への変更は即時行われます。取り消すことはできません。",
                    {
                      currentPlanName: currentPlan.plan_name + " " + t("ChangePaidPlanModalBodyForOverseas.プラン"),
                      afterPlanName: afterPlanName + " " + t("ChangePaidPlanModalBodyForOverseas.プラン"),
                      selectPaymentPeriod:
                        selectPaymentPeriod === "year"
                          ? t("ChangePaidPlanModalBodyForOverseas.年間契約")
                          : selectPaymentPeriod === "month"
                          ? t("ChangePaidPlanModalBodyForOverseas.月間契約")
                          : "",
                    },
                  )}
                  <div>
                    {
                      <Trans
                        i18nKey="ChangePaidPlanModalBodyForOverseas.申し込み内容と利用規約をご確認の上、支払い方法の選択に進んでください。"
                        components={{
                          a: (
                            <a
                              href="https://lp.yoom.fun/en/terms"
                              target="_blank"
                              rel="noreferrer"
                              style={{ position: "relative", zIndex: 1 }}
                            />
                          ),
                        }}
                      />
                    }
                  </div>
                </div>
              </>
            )}
          </>
        )}
        {Object.keys(afterPlanInfo).length ? (
          <>
            <div className={style.changePlanModalContent}>
              {downGradeFlag ? (
                <>
                  <div className={style.currentPlanGradation}></div>
                  <div className={style.changePlanModalItemContainer}>
                    <div style={{ display: "flex", flexDirection: "row", gap: "8px" }}>
                      <span className={style.changePlanName}>{afterPlanInfo?.plan_name}</span>
                      <div className={style.changePlanPeriodWrap}>
                        <div className={style.changePlanPeriod}>{afterPlanInfo?.contract_type}</div>
                      </div>
                    </div>
                    <div className={style.changePlanModalItemWrap}>
                      <div className={style.changePlanModalItem}>
                        <div className={style.changePlanModalBasicPriceTitle}>
                          {t("ChangePaidPlanModalBodyForOverseas.基本月額料金")}
                        </div>
                        <div className={style.changePlanModalBasicPriceValueWrap}>
                          <div className={style.changePlanModalBasicPriceValueItem}>
                            <div className={style.changePlanModalBasicPriceValue}>
                              {currencySymbol}
                              {afterPlanInfo?.basic_price.toLocaleString()}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "0px",
                          alignSelf: "stretch",
                          border: "1px rgba(10, 105, 130, 0.08) solid",
                        }}
                      />
                      <div className={style.changePlanModalItem}>
                        <div className={style.changePlanModalBasicPriceTitle}>
                          {t("ChangePaidPlanModalBodyForOverseas.追加タスク料金（税別）")}
                        </div>
                        <div className={style.changePlanModalBasicPriceValue}>
                          {currencySymbol}
                          {afterPlanInfo?.operation_additional_boot_price}
                        </div>
                      </div>
                    </div>
                    <div style={{ paddingTop: "16px" }}>
                      <div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center" }}>
                        <span style={{ color: "#777777", fontSize: "12px", fontWeight: "300" }}>
                          {t("ChangePaidPlanModalBodyForOverseas.契約期間")}
                        </span>
                        <span style={{ color: "#777777", fontSize: "14px", fontWeight: "400" }}>
                          {afterPlanInfo?.contract_term}
                        </span>
                      </div>
                      <div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center" }}>
                        <span style={{ color: "#777777", fontSize: "12px", fontWeight: "300" }}>
                          {t("ChangePaidPlanModalBodyForOverseas.請求予定日")}
                        </span>
                        <span style={{ color: "#777777", fontSize: "14px", fontWeight: "400" }}>
                          {afterPlanInfo?.next_payment_date}
                        </span>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className={style.currentPlanGradation}></div>

                  <div className={style.changePlanModalItemContainer}>
                    <div style={{ display: "flex", flexDirection: "row", gap: "8px" }}>
                      <span className={style.changePlanName}>{afterPlanInfo?.plan_name}</span>
                      <div className={style.changePlanPeriodWrap}>
                        <div className={style.changePlanPeriod}>{afterPlanInfo?.contract_type}</div>
                      </div>
                    </div>
                    <div className={style.changePlanModalItemWrap}>
                      <div className={style.changePlanModalItem}>
                        <div className={style.changePlanModalBasicPriceTitle}>
                          {t("ChangePaidPlanModalBodyForOverseas.基本月額料金")}
                        </div>
                        <div className={style.changePlanModalBasicPriceValueWrap}>
                          <div className={style.changePlanModalBasicPriceValueItem}>
                            <div className={style.changePlanModalBasicPriceValue}>
                              {currencySymbol}
                              {afterPlanInfo?.basic_price.toLocaleString()}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          width: "0px",
                          alignSelf: "stretch",
                          border: "1px rgba(10, 105, 130, 0.08) solid",
                        }}
                      />
                      <div className={style.changePlanModalItem}>
                        <div className={style.changePlanModalBasicPriceTitle}>
                          {t("ChangePaidPlanModalBodyForOverseas.追加タスク料金（税別）")}
                        </div>
                        <div className={style.changePlanModalBasicPriceValue}>
                          {currencySymbol}
                          {afterPlanInfo?.operation_additional_boot_price}
                        </div>
                      </div>
                    </div>
                    <div style={{ paddingTop: "16px" }}>
                      <div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center" }}>
                        <span style={{ color: "#777777", fontSize: "12px", fontWeight: "300" }}>
                          {t("ChangePaidPlanModalBodyForOverseas.契約期間")}
                        </span>
                        <span style={{ color: "#777777", fontSize: "14px", fontWeight: "400" }}>
                          {afterPlanInfo?.contract_term}
                        </span>
                      </div>
                      <div style={{ display: "flex", flexDirection: "row", gap: "8px", alignItems: "center" }}>
                        <span style={{ color: "#777777", fontSize: "12px", fontWeight: "300" }}>
                          {t("ChangePaidPlanModalBodyForOverseas.請求予定日")}
                        </span>
                        <span style={{ color: "#777777", fontSize: "14px", fontWeight: "400" }}>
                          {afterPlanInfo?.next_payment_date}
                        </span>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
            <div style={{ padding: "16px", width: "100%" }}>
              <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "8px",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span style={{ color: "#222222", fontSize: "14px", fontWeight: "500", fontFamily: "Noto Sans JP" }}>
                    {t("ChangePaidPlanModalBodyForOverseas.次回請求金額")}
                  </span>
                  <span style={{ display: "flex", flexDirection: "row", gap: "7px", alignItems: "center" }}>
                    <span style={{ color: "#222222", fontSize: "20px", fontWeight: "800" }}>
                      {currencySymbol}
                      {afterPlanInfo?.total_price.toLocaleString()}~
                    </span>
                    <img
                      src={getImageUrl("images/icons/next_payment.svg")}
                      style={{ transform: isOpen ? "rotate(180deg)" : "rotate(0deg)", cursor: "pointer" }}
                      onClick={() => setIsOpen(!isOpen)}
                    />
                  </span>
                </div>
                {isOpen && (
                  <>
                    <div
                      style={{
                        paddingTop: "40px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "16px",
                      }}
                    >
                      <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                        <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                          <div>{t("ChangePaidPlanModalBodyForOverseas.基本料金")}</div>
                          <div style={{ color: "#777777", fontSize: "12px", fontWeight: "400" }}>
                            {currencySymbol}
                            {afterPlanInfo?.basic_price.toLocaleString()} × {afterPlanInfo.billable_month_count}
                            &nbsp;{t("ChangePaidPlanModalBodyForOverseas.ヶ月")}
                            {afterPlanInfo?.discount_amount > 0 && (
                              <>
                                <span> - {currencySymbol}</span>
                                {afterPlanInfo.discount_amount.toLocaleString()} (
                                {t("ChangePaidPlanModalBodyForOverseas.初月割引")})
                              </>
                            )}
                          </div>
                        </div>
                        <div>
                          {currencySymbol}
                          {afterPlanInfo?.total_basic_price.toLocaleString()}
                        </div>
                      </div>
                      <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                        <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                          <div>{t("ChangePaidPlanModalBodyForOverseas.タスク料金")}</div>
                          <div style={{ color: "#777777", fontSize: "12px", fontWeight: "400" }}>
                            {currencySymbol}
                            {afterPlanInfo?.operation_additional_boot_price} × {afterPlanInfo?.billable_month_count}
                            &nbsp;{t("ChangePaidPlanModalBodyForOverseas.ヶ月")}
                          </div>
                        </div>
                        <div style={{ display: "flex", gap: "8px" }}>
                          <div>{currencySymbol}-</div>
                          <div style={{ color: "#777777", fontSize: "11px", fontWeight: "400" }}>※</div>
                        </div>
                      </div>
                      {afterPlanInfo?.repayable_total_basic_price > 0 && (
                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                          <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                            <div>{t("ChangePaidPlanModalBody.前プラン残期間割引")}</div>
                            {afterPlanInfo?.current_basic_price > 0 && (
                              <div style={{ color: "#777777", fontSize: "12px", fontWeight: "400" }}>
                                -{currencySymbol}
                                {afterPlanInfo?.current_basic_price.toLocaleString()} ×
                                {afterPlanInfo?.repayable_month_count} {t("ChangePaidPlanModalBodyForOverseas.ヶ月")}
                              </div>
                            )}
                            {afterPlanInfo?.repayable_total_license_price > 0 && (
                              <div style={{ color: "#777777", fontSize: "12px", fontWeight: "400" }}>
                                -{currencySymbol}
                                {afterPlanInfo?.repayable_total_license_price.toLocaleString()} ×
                                {afterPlanInfo?.repayable_month_count} {t("ChangePaidPlanModalBodyForOverseas.ヶ月")} ×{" "}
                                {afterPlanInfo?.repayable_license_count} {t("ChangePaidPlanModalBodyForOverseas.人")}
                              </div>
                            )}
                          </div>
                          <div>
                            -{currencySymbol}
                            {afterPlanInfo?.repayable_total_basic_price.toLocaleString()}
                          </div>
                        </div>
                      )}
                      <div style={{ width: "100%", height: "1px", border: "1px #E6E6E6 solid" }} />
                    </div>
                  </>
                )}
                <div style={{ display: "flex", flexDirection: "column", gap: "7px" }}>
                  {isOpen && (
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                      <div>{t("ChangePaidPlanModalBodyForOverseas.合計金額")}</div>
                      <div>
                        {currencySymbol}
                        {afterPlanInfo?.total_price.toLocaleString()}
                      </div>
                    </div>
                  )}
                  <div style={{ color: "#777777", fontSize: "12px", fontWeight: "300", textAlign: "right" }}>
                    {t("ChangePaidPlanModalBodyForOverseas.請求日までの追加タスク料金が追加されます")}
                  </div>
                </div>
              </div>
            </div>
            <div className={style.changePlanModalButtonWrap}>
              <SecondaryBtn
                text={t("ChangePaidPlanModalBodyForOverseas.戻る")}
                disabled={false}
                className={`test-force-upgrade ${style.changePlanModalButton}`}
                submit={() => handleClose()}
                style={{ color: "#222222" }}
              />
              {currentPlan?.is_via_partner ? (
                <InfoBtn
                  text={t("ChangePaidPlanModalBodyForOverseas.申し込む")}
                  loading={isLoading}
                  className={`test-force-upgrade ${style.changePlanModalButton}`}
                  submit={() => updatePlan(true)}
                />
              ) : (
                <InfoBtn
                  text={t("ChangePaidPlanModalBodyForOverseas.支払い方法の選択へ")}
                  loading={false}
                  className={`test-force-upgrade ${style.changePlanModalButton}`}
                  submit={() => {
                    setCurrentPageNumber(1);
                    changeModalCss("auto", "auto");
                  }}
                />
              )}
            </div>
          </>
        ) : (
          <div className={style.changePlanModalButtonWrap}>
            <InfoBtn
              text={t("ChangePaidPlanModalBodyForOverseas.申し込む")}
              loading={isLoading}
              className={`test-force-upgrade ${style.changePlanModalButton}`}
              submit={() => updatePlan(true)}
            />
          </div>
        )}
      </div>
    </>
  );
};

ChangePaidPlanModalBodyForOverseas.propTypes = {
  currentPlan: PropTypes.object,
  currentPaymentPeriod: PropTypes.string,
  afterPlanName: PropTypes.string,
  afterPlanInfo: PropTypes.object,
  selectPaymentPeriod: PropTypes.string,
  downGradeFlag: PropTypes.bool,
  isLoading: PropTypes.bool,
  handleClose: PropTypes.func,
  updatePlan: PropTypes.func,
  setCurrentPageNumber: PropTypes.func,
  changeModalCss: PropTypes.func,
  currency: PropTypes.object,
};
